<template>
    <b-card :header-html="
        `<h4><i class='fa fa-suitcase'></i> Dados da empresa</h4>`
    ">           
        <b-row cols="12" cols-md="4">
            <b-col>
                <b-form-group 
                    label-for="tipo"
                    label="Tipo de pessoa" 
                    class="required">
                    <b-form-select 
                        id="tipo" v-model="data.Loja.tipo_pessoa">
                            <option value="PF">Pessoa física</option>
                            <option value="PJ">Pessoa jurídica</option>
                    </b-form-select>
                </b-form-group>
            </b-col>
            <b-col :md="data.Loja.tipo_pessoa == 'PJ' ? 9 : 6">
                <b-row>
                    <b-col md="6">
                        <b-form-group 
                            label-for="fantasia" 
                            :label="`Nome ${ data.Loja.tipo_pessoa == 'PJ' ? 'fantasia' : 'da empresa'}`"
                            class="required">
                            <b-form-input
                                id="fantasia"
                                name="fantasia"
                                ref="inputNomeEmpresa"
                                v-validate="'required'"
                                v-model="data.Loja.nome_fantasia"
                                :class="[{ error: errors.first('fantasia') }]"
                            />
                        </b-form-group>
                    </b-col>
                    <b-col md="6">
                        <b-form-group label-for="razao_social" label="Razão social">
                            <b-form-input
                                id="razao_social"
                                name="razao_social"
                                v-model="data.Empresa.razao_social"
                            />
                        </b-form-group>
                    </b-col>
                </b-row>
            </b-col>
            <b-col sm="12" v-show="data.Loja.tipo_pessoa == 'PJ'">
                <b-form-group 
                    label="CNPJ" label-for="cnpj" class="required">
                    <b-form-input
                        id="cnpj" name="cnpj" 
                        :class="[{ error: errors.first('cnpj') }]"
                        v-mascara-cnpj v-model="data.Empresa.cnpj" 
                        v-validate="data.Loja.tipo_pessoa == 'PJ' ? 'cnpj|required' : ''"
                    />
                    <span v-show="errors.has('cnpj')" class="text-danger">
                        {{ errors.first('cnpj') }}
                    </span>
                </b-form-group>
            </b-col>
            <b-col sm="12" v-if="data.Loja.tipo_pessoa == 'PF'" >
                <b-form-group label-for="cpf" label="CPF" class="required">
                    <b-form-input
                        id="cpf" name="cpf"
                        :class="[{ error: errors.first('cpf') }]"
                        v-mascara-cpf v-model="data.Loja.cpf"
                        v-validate="data.Loja.tipo_pessoa == 'PF' ? 'cpf|required' : ''"
                    />
                    <span v-show="errors.has('cpf')" class="text-danger">
                        {{ errors.first('cpf') }}
                    </span>
                </b-form-group>        
            </b-col>
            <b-col sm="12" v-show="data.Loja.tipo_pessoa == 'PF'">
                <b-form-group label-for="rg" label="RG" class="required">
                    <b-form-input
                        id="rg" name="rg"
                        v-model="data.Loja.documento"
                        :class="[{ error: errors.first('rg') }]"
                        v-validate="data.Loja.tipo_pessoa == 'PF' ? 'required' : ''"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="12">
                <b-form-group 
                    label-for="nome_usuario" 
                    label="Nome completo"
                    class="required">
                    <b-form-input
                        id="nome_usuario"
                        name="nome_usuario"
                        v-validate="'required'"
                        v-model="data.Usuario.nome"
                        :class="[{ error: errors.first('nome_usuario') }]"
                    />
                </b-form-group>
            </b-col>
            <b-col sm="12">
                <b-form-group 
                    label-for="telefone" 
                    label="Telefone"
                    class="required">
                    <b-form-input
                        id="telefone"
                        name="telefone"
                        v-mascara-telefone
                        v-model="data.Loja.telefone"
                        v-validate="'required'"
                        :class="[{ error: errors.first('telefone') }]"
                    />
                </b-form-group>
            </b-col>
            <b-col>
                <b-form-group 
                    label-for="whatsapp" 
                    label="Whatsapp"
                    class="required">
                    <b-form-input
                        id="whatsapp"
                        name="whatsapp"
                        v-mascara-telefone
                        v-model="data.Loja.whatsapp"
                        v-validate="'required'"
                        :class="[{ error: errors.first('whatsapp') }]"
                    />
                </b-form-group>
            </b-col>
        </b-row>
    </b-card>
</template>
<script>
export default {
    inject: ['$validator'],
    props: {
        data: {
            default: {}
        }
    },
    async mounted () {
        this.$refs.inputNomeEmpresa.focus()
        this.data.Empresa.tipo = this.$url.module == 'contabilidade' ? 'C' : 'P'
        if (this.$app) {
            this.data.Empresa.dominio_id = String(this.$app.id)
            this.data.Empresa.usuario_id = String(this.$app.usuario_id)
        }
    },
}
</script>